import React from 'react'
import { Box, CircularProgress, Dialog, Typography } from '@mui/material'

const UpdatingModal = ({ open }) => (
  <Dialog
    open={open}
    disableEscapeKeyDown
    disableBackdropClick
    PaperProps={{
      style: {
        backgroundColor: 'transparent',
        boxShadow: 'none'
      }
    }}
    data-test='updating-modal'
    aria-labelledby='updating-modal-title'
    aria-describedby='updating-modal-description'
  >
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      p={4}
      data-test='updating-modal-content'
    >
      <CircularProgress size={60} data-test='updating-spinner' aria-label='Loading' />
      <Typography
        id='updating-modal-title'
        variant='h6'
        sx={{ mt: 2, color: 'white' }}
        data-test='updating-text'
      >
        Updating your profile...
      </Typography>
    </Box>
  </Dialog>
)

export default UpdatingModal
